/**
 * @file page
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import LikeBtn from '../../components/LikeBtn';
import ShadeImg from '../../components/ShadeImg';
import ListPro from '../../components/ListPro';
import TopBar from '../../components/TopBar';

import {fetchCmsapiGetArticleData, fetchCmsapiZan} from '../../actions/pageAction';

import './index.less';

export class Page extends Component {

    static propTypes = {
        fetchCmsapiGetArticleData: PropTypes.func,
        fetchCmsapiZan: PropTypes.func,
        cmsapiGetArticleData: PropTypes.object,
        history: PropTypes.object,
        match: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            zan: 0,
            showOff: false,
            aId: this.props.match.params.aId
        };

        this.forumLikes = JSON.parse(localStorage.getItem('forumLikes')) || [];
        this.LikeBtnClick = this.LikeBtnClick.bind(this);
    }

    componentWillMount() {
        if (this.isPC()) {
            const aId = this.props.match.params.aId;
            location.href = aId ? `/article/${aId}`
                : '/article';
        }
    }

    componentDidMount() {
        this.props.fetchCmsapiGetArticleData({
            aid: this.state.aId
        }).then(data => {
            const resData = data.data;
            if (resData.is_error === 0) {
                this.setState({
                    zan: +resData.itemlist.article_detail.zan,
                    showOff: true
                });

                this.shareWX({
                    title: resData.itemlist.article_detail.title,
                    content: resData.itemlist.article_detail.subtitle
                });
            } else {
                this.props.history.push('/forum');
            }
        });
    }

    LikeBtnClick() {
        const {
            aId,
            zan
        } = this.state;

        this.props.fetchCmsapiZan({
            aid: aId
        }).then(data => {
            if (data.data.is_error === 0) {
                this.forumLikes.push(aId);
                localStorage.setItem('forumLikes', JSON.stringify(this.forumLikes));

                this.setState({
                    zan: zan + 1
                });
            }
        });

    }

    render() {
        const cmsapiGetArticleData = this.props.cmsapiGetArticleData.itemlist;
        const articleDetail = cmsapiGetArticleData ? cmsapiGetArticleData.article_detail : {};
        const mobileAdRecommend = cmsapiGetArticleData ? cmsapiGetArticleData.mobile_ad_recommend : false;
        const recommendRead = cmsapiGetArticleData ? cmsapiGetArticleData.recommend_read : [];
        const {aId, showOff} = this.state;

        if (!cmsapiGetArticleData) {
            return null;
        }

        return (
            <div>
                <div className={'top-bar-box'}>
                    <TopBar/>
                </div>
                {showOff
                    ? <div className={'page pt130'}>
                        <h1 className={'section'}>
                            {articleDetail.title}
                        </h1>
                        <div className={'section page-info'}>
                            <span>
                                <span className="page-time">{articleDetail.publish_time.slice(5, 10)}</span>
                                {articleDetail.pv}人阅读
                            </span>
                        </div>
                        <div className={'page-conter section'} dangerouslySetInnerHTML={{
                            __html: articleDetail.content
                        }}>
                        </div>
                        <div className={'mark-tab mui-flex section detail-label'}>
                            {articleDetail.tags_data && articleDetail.tags_data.map(item => {
                                return <a
                                    href={`/m/forum/mark/${item.tagid}`}
                                    key={item.tagid}
                                    className={'align-center insert-btn'}>
                                    {item.tagname}
                                </a>;
                            })}
                        </div>

                        <div style={{
                            textAlign: 'center',
                            marginTop: '0.6rem',
                            marginBottom: '0.8rem'
                        }}>
                            <LikeBtn
                                num={this.state.zan}
                                hasLike={this.forumLikes.indexOf(aId) > -1}
                                handleClick={this.LikeBtnClick}/>
                        </div>

                        {mobileAdRecommend && <div className={'insert-box section'}>
                            <ShadeImg
                                title={mobileAdRecommend.title}
                                text={mobileAdRecommend.subtitle}
                                imgAlt={mobileAdRecommend.title}
                                imgSrc={mobileAdRecommend.pic}
                                href={mobileAdRecommend.url}/>
                            <div className={'insert-mod just-end'}>
                                <a href={mobileAdRecommend.url} className={'insert-btn align-center just-center'}>
                                    {mobileAdRecommend.button_toast}
                                </a>
                            </div>
                        </div>}

                        {recommendRead && recommendRead.length !== 0 && <div style={{paddingBottom: '0.8rem'}}>
                            <div className={'nominate-page section'}>
                                推荐阅读
                            </div>

                            <div className={'page-box'}>
                                {recommendRead.map(item => {
                                    return <a href={`/m/forum/page/${item.aid}`} key={item.aid} className={'section'}>
                                        <ListPro
                                            title={item.title}
                                            time={item.publish_time.slice(5, 10)}
                                            brief={`${item.pv}人阅读`}
                                            imgSrc={item.pic}
                                        />
                                    </a>;
                                })}
                            </div>

                        </div>}
                    </div> : <div style={{minHeight: '100vh'}}></div>
                }

            </div>

        );
    }
}


function mapStateToProps(state) {
    return {
        cmsapiGetArticleData: state.cmsapiGetArticleData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCmsapiGetArticleData: aidObj => fetchCmsapiGetArticleData(dispatch, aidObj),
        fetchCmsapiZan: aidObj => fetchCmsapiZan(dispatch, aidObj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Page);





// WEBPACK FOOTER //
// ./src/containers/page/index.js